var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 18,
    height: 18,
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-My_Performance"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Performance",
    "data-name": "My Performance",
    clipPath: "url(#clip-My_Performance)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-1 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_010cdbd9605c3b5aca5c190ae5a209e5",
    "data-name": "010cdbd9605c3b5aca5c190ae5a209e5",
    d: "M18.769,19.726H16.994V12.755h.592a.183.183,0,0,0,.143-.3l-1.55-1.928a.107.107,0,0,1-.028-.028l-.015-.008a.177.177,0,0,0-.033-.017l-.032-.01a.183.183,0,0,0-.037,0,.186.186,0,0,0-.035,0l-.032.01a.166.166,0,0,0-.033.017l-.015.008c-.005,0-.008.01-.013.015s-.011.007-.015.013l-1.55,1.928a.183.183,0,0,0,.143.3h.592v6.971H13.132v-5.08h.592a.183.183,0,0,0,.143-.3l-1.55-1.928c0-.005-.01-.008-.015-.012l-.013-.015s-.01,0-.015-.008a.2.2,0,0,0-.033-.017l-.032-.01a.208.208,0,0,0-.069,0l-.032.01a.2.2,0,0,0-.033.017s-.01,0-.015.008-.008.011-.012.015-.011.007-.015.012l-1.55,1.928a.183.183,0,0,0,.143.3h.593v5.08H9.27V16.535h.592a.183.183,0,0,0,.142-.3L8.454,14.31,8.44,14.3l-.013-.015s-.01,0-.015-.008a.179.179,0,0,0-.032-.017l-.033-.01a.205.205,0,0,0-.069,0,.175.175,0,0,0-.033.01.2.2,0,0,0-.033.017s-.011,0-.015.008l-.013.015-.015.013L6.62,16.238a.183.183,0,0,0,.142.3h.592v3.191H5.6V9.658a.183.183,0,1,0-.365,0V19.909a.183.183,0,0,0,.183.183H18.769a.183.183,0,0,0,0-.365ZM15.261,12.39h-.393l1.17-1.454,1.17,1.454h-.4a.183.183,0,0,0-.183.183v7.154H15.444V12.573a.183.183,0,0,0-.183-.183ZM11.4,14.28h-.394l1.17-1.453,1.17,1.453h-.4a.183.183,0,0,0-.183.183v5.263H11.583V14.463A.183.183,0,0,0,11.4,14.28ZM7.537,16.17H7.144l1.17-1.453,1.17,1.453h-.4a.183.183,0,0,0-.183.183v3.374H7.72V16.352A.183.183,0,0,0,7.537,16.17Z",
    transform: "translate(-2.969 -5.259)",
    stroke: "#505050",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPerformance);
export default __webpack_public_path__ + "static/media/My Performance.8f82c7db9ab55bb23ec2e8014753d9cc.svg";
export { ForwardRef as ReactComponent };